import { EndpointSetting } from "@/constants/app/type";
import { UserState } from "../type";
import { setCookie, setLocalStorage } from "@/utils/app/storage";

export const callbackSetNewPassword: EndpointSetting['caller'] = (
  state: UserState,
  action: any,
  endpointName: any
) => {
  state.set_new_password.loading = false;
  state.set_new_password.error = null;
  state.set_new_password.success = true;
  state.set_new_password.data = action.payload;
  
  // If the API returns user info and token, update the state and store them
  if (action.payload?.accessToken && action.payload?.customer) {
    state.profile.data = action.payload.customer;
    state.isAuthen = true;
    setLocalStorage("user", action.payload.customer);
    setCookie("token", action.payload.accessToken);
  }
}